import { defineMessages } from 'react-intl';
import { addSchemaField } from 'iovisit-theme/config';

const messages = defineMessages({
  show_icon: {
    id: 'show_icon',
    defaultMessage: "Mostra l'icona",
  },
  show_thematic_area: {
    id: 'show_thematic_area',
    defaultMessage: "Mostra l'area tematica",
  },
  image_size: {
    id: 'image_size',
    defaultMessage: "Dimensione dell'immagine",
  },
  show_item_description: {
    id: 'show_item_description',
    defaultMessage: 'Mostra la descrizione',
  },
});

const getCardsVariationSchema = (schema, formData, intl, pos = 0) => {
  addSchemaField(
    schema,
    'image_size',
    intl.formatMessage(messages.image_size),
    null,
    {
      type: 'size',
      default: 'm',
      sizes: [
        { value: 's', title: 'S' },
        { value: 'm', title: 'M' },
      ],
    },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'show_icon',
    intl.formatMessage(messages.show_icon),
    null,
    { type: 'boolean', default: true },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'show_thematic_area',
    intl.formatMessage(messages.show_thematic_area),
    null,
    { type: 'boolean', default: true },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'show_item_description',
    intl.formatMessage(messages.show_item_description),
    null,
    { type: 'boolean', default: true },
    pos,
  );
  pos++;

  return pos;
};

export default getCardsVariationSchema;
